import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const FEATURE_COPY = {
  exports: {
    title: "Exports & Reports are Pro",
    desc: "Download your full beekeeping history as CSV or printable annual reports.",
  },
  trends: {
    title: "Health Trends are Pro",
    desc: "Visualise per-hive inspections, harvests and treatments over time.",
  },
  "compare-hives": {
    title: "Compare hives is Pro",
    desc: "Stack your hives side-by-side and instantly see who's thriving.",
  },
  treatments: {
    title: "Treatments tracker is Pro",
    desc: "Log varroa treatments and feedings with auto follow-up reminders and withdrawal periods.",
  },
  yards: {
    title: "Multi-apiary is Pro",
    desc: "Add unlimited yards / apiaries — perfect for hobbyists running bees in more than one location.",
  },
  weather: {
    title: "Inspection Forecast is Pro",
    desc: "5-day weather forecast for each hive, with green/yellow/red ratings tailored to bee-handling conditions.",
  },
  voice_journal: {
    title: "Voice journaling is Pro",
    desc: "Talk into your phone during an inspection — we transcribe and auto-fill the journal entry for you.",
  },
  predictions: {
    title: "Smart Calendar is Pro",
    desc: "Predictive treatment, inspection and seasonal nudges tailored to each hive's location and history.",
  },
};

export default function ProUpsell({ open, onOpenChange, feature = "trends" }) {
  const navigate = useNavigate();
  const copy = FEATURE_COPY[feature] || FEATURE_COPY.trends;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="pro-upsell-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-amber-500" />
            {copy.title}
          </DialogTitle>
          <DialogDescription>{copy.desc}</DialogDescription>
        </DialogHeader>
        <ul className="text-sm text-stone-700 space-y-1.5 py-2 list-disc list-inside">
          <li>Unlimited AI diagnoses & video uploads</li>
          <li>Multi-apiary support, exports, trends, treatments</li>
          <li>Cancel anytime — backed by Stripe</li>
        </ul>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)} data-testid="pro-upsell-cancel">
            Not now
          </Button>
          <Button
            className="bg-amber-500 hover:bg-amber-400 text-stone-950 font-bold"
            onClick={() => {
              onOpenChange(false);
              navigate("/app/settings?tab=billing");
            }}
            data-testid="pro-upsell-upgrade"
          >
            See plans
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
